import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';

import type { PopupData, Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import ScorecardPreviewLineComponent from 'webapp/components/scorecard/preview/line';

export default class ScorecardPreviewPopupComponent extends PopupInnerModalComponent<PopupData.Scorecard.Preview> {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;
	@service('account') declare accountService: Service.Account;
	@service('model-manager/notifications')
	declare mmNotificationsService: Service.ModelManager.Notifications;
	@service('model-manager/scorecards')
	declare mmScorecardsService: Service.ModelManager.Scorecards;

	get items() {
		return this.popupData.items;
	}

	get colorStyle() {
		const color = this.popupData.color;
		let bgStyle = '';

		if (color) {
			bgStyle = this.mmBoardsService.getColorGradient(color);
		}
		return htmlSafe(bgStyle);
	}

	@action
	configure() {
		if (this.accountService.handleDemo()) {
			return;
		}

		const scorecardId = this.popupData.id;

		if (scorecardId) {
			const scorecard = this.mmScorecardsService.findModel(scorecardId);
			if (scorecard) {
				this.mmNotificationsService.openEditPopupWithTransition(scorecard);
			}
		} else {
			this.navigationService.transitionToRoute('settings.notifications');
		}

		this.close();
	}

	@action
	debounceScheduleReposition() {
		debounce(this, this.scheduleReposition, 100);
	}
	<template>
		<div class="title" style={{this.colorStyle}}>
			<span class="date">{{this.popupData.dateIntervalText}}</span>
			<div class="t">{{this.popupData.title}}</div>
		</div>

		<div class="content scorecard-preview">

			<div class="metrics">
				<table width="100%" cellspacing="0" cellpadding="0">
					<tbody>
						{{#each this.items as |item|}}
							<ScorecardPreviewLineComponent
								@model={{item}}
								@onLoaded={{this.debounceScheduleReposition}}
							/>
						{{/each}}
					</tbody>
				</table>
			</div>

			{{#unless this.popupData.isMobileApp}}
				<div class="bottom">
					<a role="button" class="configure" {{on "click" this.configure}}>
						<CommonUiIconComponent @name="Preferences" @size="sm" />
						Edit
					</a>
				</div>
			{{/unless}}
		</div>
	</template>
}
